const QueryErrorState = ({
  error,
  onRetry,
  title = "Impossible de charger les données",
  className = "",
}) => {
  const isOffline = typeof navigator !== "undefined" && !navigator.onLine;
  const status = error?.response?.status;
  const isForbidden = status === 403;
  const isNotFound = status === 404;
  const statusTitle = isForbidden
    ? "Acc\u00e8s refus\u00e9"
    : isNotFound
      ? "Intervention introuvable"
      : title;
  const statusMessage = isForbidden
    ? "Cette intervention est r\u00e9serv\u00e9e au client et au prestataire concern\u00e9s."
    : isNotFound
      ? "Cette intervention n'existe pas ou n'est plus disponible."
      : null;
  const message = isOffline
    ? "Vous êtes hors ligne. Vérifiez votre connexion puis réessayez."
    : status >= 500
      ? "Le service est momentanément indisponible. Réessayez dans quelques instants."
      : "La récupération des données a échoué. Vérifiez votre connexion puis réessayez.";

  return (
    <div
      className={`w-full min-h-[220px] rounded-2xl border border-solid border-[#F3D5C3] bg-white px-6 py-8 flex flex-col items-center justify-center gap-3 text-center ${className}`}
      role="alert"
      aria-live="assertive"
    >
      <div className="w-12 h-12 rounded-full bg-[#FFF1E8] text-[#FF6600] flex items-center justify-center text-xl">
        <i className="fi fi-rr-cloud-disabled flex items-center" aria-hidden="true"></i>
      </div>
      <div className="font-semibold text-[#19295C]">{statusTitle}</div>
      <div className="max-w-lg text-sm text-[#7E7E7E]">{statusMessage ?? message}</div>
      {onRetry && !isForbidden && !isNotFound && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 min-h-10 rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] px-5 py-2 text-sm font-semibold text-white"
        >
          Réessayer
        </button>
      )}
    </div>
  );
};

export default QueryErrorState;
